import styled from "../../styled-components.js";
export var Label = styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-17gd8mo-0"
})(["display:flex;position:relative;min-inline-size:0;"]);